import { I18nDictionaryLanguageKeysType } from './types'

export const languagesShortMap: Record<I18nDictionaryLanguageKeysType, I18nDictionaryLanguageKeysType> = {
  id: 'id',
  ar: 'ar',
  de: 'de',
  en: 'en',
  es: 'es',
  it: 'it',
  pt: 'pt',
  ru: 'ru',
  sv: 'sv',
  th: 'th',
  vi: 'vi',
  zh: 'zh',
}

export const languagesMap: Record<I18nDictionaryLanguageKeysType, string> = {
  id: 'id_ID',
  ar: 'ar_KW',
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  it: 'it_IT',
  pt: 'pt_PT',
  ru: 'ru_RU',
  sv: 'sv_SE',
  th: 'th_TH',
  vi: 'vi_VN',
  zh: 'zh_CN',
}

export const transformCabinetTranslationKeyToAdminTranslationKey = {
  [languagesMap.ar]: 'ar_AR',
}

export const transformCabinetTranslationKeyToCoreTranslationKey = {
  [languagesShortMap.ar]: 'ar_AR',
}

export const languagesKeys = Object.keys(languagesMap) as I18nDictionaryLanguageKeysType[]

export const languagesNameMap: Record<I18nDictionaryLanguageKeysType, string> = {
  id: 'Bahasa Indonesia',
  ar: 'العربيةُ',
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  it: 'Italiano',
  pt: 'Português',
  ru: 'Русский',
  sv: 'Svenska',
  th: 'ไทย',
  vi: 'Tiếng Việt',
  zh: '中文',
}
